import React, { useEffect } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import {
  useUnlinkFailedDisbursementInstructionsMutation
} from '../../../api-services/payments/paymentsApi'
import { setNotification } from '../ui-widgets/uiWidgetsSlice'
import { setUnlinkActions } from '../../pages/finance-area/disbursements/disbursementsSlice'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { Button } from '@mui/material'
import { type DisbursementBatchDetails } from '../../../api-schema-types/payments/DisbursementBatchDomainDtos'

interface UnlinkFailedInstructionsComponentProps {
  disbursementBatch: DisbursementBatchDetails
  disbursementInstructionIds: number[]
}

const UnlinkFailedInstructionsComponent: React.FC<UnlinkFailedInstructionsComponentProps> = ({ disbursementInstructionIds, disbursementBatch }) => {
  const dispatch = useAppDispatch()

  const [apiUnlinkFailedInstructionsTrigger, apiUnlinkInstructionsResult] = useUnlinkFailedDisbursementInstructionsMutation()
  const handleUnlinkFailedInstructions = async (): Promise<void> => {
    const choice = window.confirm(
      'Are you sure you want to unlink instructions from this batch?'
    )
    if (choice) {
      await apiUnlinkFailedInstructionsTrigger({ disbursementBatchId: disbursementBatch.disbursementBatchId, disbursementInstructionIds })
    }
  }

  useEffect(() => {
    if (apiUnlinkInstructionsResult.isSuccess) {
      dispatch(setNotification({
        open: true,
        severity: 'success',
        message: `${disbursementInstructionIds.length} instructions unlinked from disbursement batch ${apiUnlinkInstructionsResult.data.disbursementBatchId} cancelled.`
      }))
      dispatch(setUnlinkActions([]))
    }

    if (apiUnlinkInstructionsResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiUnlinkInstructionsResult.error) }))
    }
  }, [apiUnlinkInstructionsResult.isSuccess, apiUnlinkInstructionsResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} color={'warning'}
              sx={{ mr: 2 }}
              disabled={!(disbursementBatch.state === 'EXPORTED' && disbursementInstructionIds.length > 0)}
              onClick={handleUnlinkFailedInstructions}>
        Unlink Failed Instructions
      </Button>
    </>
  )
}

export default UnlinkFailedInstructionsComponent
